<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Live MT4</a>
            </div>
        </div>
        <div class="box-body">
            <ul class="mt4-account-list-view clearfix">
                <li class="mt4-account-list-item" v-for="item in mt4_account_list">
                    <div class="title-view clearfix">
                        <p class="left-text">#{{item.number}}</p>
                        <div class="right">
                            <el-dropdown trigger="click">
                                <i class="iconfont icon-shezhi1"></i>
                                <el-dropdown-menu slot="dropdown" class="mt4-account-dropdown">
                                    <el-dropdown-item>
                                        <router-link class="span-item" :to="{name:'deposit'}">Deposit</router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="span-item"
                                                     :to="{name:'Withdraw',params:{'mt4_id':item.number}}">Withdraw
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="span-item"
                                                     :to="{name:'transfer',params:{'mt4_id':item.number}}">Transfer
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item><span class="span-item" @click="change_leverage(item)"> Change Leverage</span>
                                    </el-dropdown-item>
                                    <!--  <el-dropdown-item><span class="span-item" @click="change_account()"> Password Rest</span></el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="main">
                        <p>NUMBER <strong>{{item.number}}</strong></p>
                        <p>TYPE <strong>{{item.type}}</strong></p>
                        <p>SERVER <strong>{{item.server}}</strong></p>
                        <template>
                            <p v-if="item.mt4_info.CURRENCY">
                                BALANCE
                                <strong>
                                    {{item.mt4_info.BALANCE}}
                                    {{item.mt4_info.CURRENCY}}
                                </strong>
                            </p>
                            <p v-else-if="(live_current_mt4_info.mt4===item.number)">
                                BALANCE
                                <strong>
                                    {{item.mt4_info.BALANCE}}
                                    {{live_current_mt4_info.account_currency}}
                                </strong>
                            </p>
                        </template>
                        <p>LEVERAGE <strong>1:{{item.leverage}}</strong></p>
                    </div>
                </li>
                <li class="mt4-account-list-item create-mt4-account-list-item">
                    <router-link :to="{ name: 'CreateLiveMT4'}">
                        <img src="../../assets/img/model_icon_img/add_icon.png" alt="">
                        <p>OPEN NEW LIVE ACCOUNT</p>
                    </router-link>
                </li>
            </ul>
        </div>

        <el-dialog
                :visible.sync="change_leverage_dialog_visible"
                width="520px"
                class="mt4-account-dialog change-leverage-dialog"
        >
            <h3 class="title">Change Leverage</h3>
            <div class="select-view">
                <label for="">Leverage</label>
                <el-select v-model="change_leverage_value" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <p class="info">Note: Your chosen Trading Account leverage only
                applies to your FX trades, other instruments you trade may have their respective
                leverages that apply to them. For more information please refer to product specification.</p>
            <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="box-btn" style="width:200px" @click="post_change_leverage">Submit</el-button>
        </span>
        </el-dialog>

        <el-dialog
                :visible.sync="change_account_dialog_visible"
                width="520px"
                class="mt4-account-dialog change-account-dialog"
        >
            <h3 class="title">Change Account Password</h3>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px"
                     class="change-account-ruleForm">
                <el-form-item label="The new password" prop="the_password">
                    <el-input v-model="ruleForm.the_password"></el-input>
                </el-form-item>
                <el-form-item label="Confirm password" prop="confirm_password">
                    <el-input v-model="ruleForm.confirm_password"></el-input>
                </el-form-item>
                <el-form-item label="Mobile phone" prop="confirm_password">
                    13713856412
                </el-form-item>
                <el-form-item label="Mobile password" prop="mobile_password">
                    <el-input v-model="ruleForm.mobile_password" style="width:150px;"></el-input>
                    <el-button class="box-btn" style="width:80px;margin-left:5px;">60s Resend passcode</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="box-btn" style="width:200px;" @click="submitForm('ruleForm')">
                        Submit
                    </el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">  </span>
        </el-dialog>

    </div>
</template>

<script>
  import * as server from './action'

  export default {
    data () {
      let msgboxOption = {
        dangerouslyUseHTMLString: true,
        center: true,
        customClass: 'mt4-view-msgbox',
        showClose: false
      }
      return {
        change_leverage_dialog_visible: false,
        change_account_dialog_visible: false,
        current_mt4_id: '',
        curr_mt4_id: '',
        options: [
          {
            value: '100',
            label: '1% (1:100)'
          },
          {
            value: '50',
            label: '2% (1:50)'
          },
          {
            value: '30',
            label: '3.33% (1:30)'
          },
          {
            value: '20',
            label: '5% (1:20)'
          },
          {
            value: '10',
            label: '10% (1:10)'
          },
          {
            value: '5',
            label: '20% (1:5)'
          },
          {
            value: '2',
            label: '50% (1:2)'
          }
        ],
        ruleForm: {
          the_password: '',
          confirm_password: '',
          mobile_password: ''
        },
        rules: {
          the_password: [
            {required: true, message: 'Please Select', trigger: 'blur'}
          ],
          confirm_password: [
            {required: true, message: 'Please Select', trigger: 'change'}
          ],
          mobile_password: [
            {required: true, message: 'Please Select', trigger: 'change'}
          ]
        },
        change_leverage_value: '',
        mt4_account_list: [],
        msgboxSuccess: {
          ...msgboxOption,
          iconClass: 'ico-box ico-success',
          confirmButtonText: 'Continue'
        },
        msgboxWarning: {
          ...msgboxOption,
          iconClass: 'ico-box ico-warning',
          confirmButtonText: 'OK'
        },
        msgboxFailed: {
          ...msgboxOption,
          iconClass: 'ico-box ico-failed',
          confirmButtonText: 'OK'
        },
        live_current_mt4_info: {}
      }
    },
    beforeRouteEnter (to, from, next) {
      server
        .get_mt4_account_list({is_demo: 0})
        .then(data => {
          next(vm => vm.setinfo(data))
        })
        .catch(() => {
          next()
        })
    },
    created () {
      this.live_current_mt4_info.mt4 = localStorage.live_mt4 ? localStorage.live_mt4 : ''
      this.live_current_mt4_info.account_currency = localStorage.live_account_currency ? localStorage.live_account_currency : ''
    },
    methods: {
      setinfo (val) {
        console.log('val', val)
        this.mt4_account_list = val
      },
      change_leverage (val) {
        this.current_mt4_id = val.id
        this.curr_mt4_id = val.number
        this.change_leverage_value = String(val.leverage)
        this.change_leverage_dialog_visible = true
      },
      change_account () {
        this.change_account_dialog_visible = true
      },
      submitForm (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            alert('submit!')
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      },
      post_change_leverage (val) {
        let params = {
          id: this.current_mt4_id,
          leverage: this.change_leverage_value
        }
        server
          .change_leverage(params)
          .then(data => {
            this.change_leverage_dialog_visible = false
            this.$alert(
              `<h3>Submit successful.</h3> <br>
The leverage of your trading account ${this.curr_mt4_id} is now:${
                data.leverage
                }.`,
              this.msgboxSuccess
            ).then(() => {
              window.location.reload()
            })
            console.log(11, data)
          })
          .catch(() => {})
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .mt4-account-list-view {
        .mt4-account-list-item {
            width: 237px;
            height: 250px;
            float: left;
            position: relative;
            border: 1px solid #ddd;
            padding: 20px 20px 30px;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 20px;
            &:nth-of-type(4n) {
                margin-right: 0;
            }
            .title-view {
                margin-bottom: 25px;
                .left-text {
                    float: left;
                    color: #0A95FF;
                    font-weight: bold;
                }
                .right {
                    float: right;
                    cursor: pointer;
                    margin-top: -5px;
                    .iconfont {
                        color: #0A95FF;
                        font-size: 22px;
                    }
                }
            }
            .main {
                p {
                    font-size: 14px;
                    margin-bottom: 10px;
                    strong {
                        float: right;
                        font-weight: normal;
                    }
                }
            }
        }
        .create-mt4-account-list-item {
            border: 1px dashed #0A95FF;
            text-align: center;
            padding: 0;
            cursor: pointer;
            a {
                display: block;
                height: 250px;
                overflow: hidden;
            }
            img {
                margin: 60px auto 20px;
            }
            p {
                font-size: 14px;
            }
        }
    }

    .mt4-account-dropdown.el-dropdown-menu {
        background: #eeeeee;
        .span-item {
            display: block;
            padding: 0 20px;
            &:hover{
                color: #ffffff;
            }
        }
        .el-dropdown-menu__item:focus,
        .el-dropdown-menu__item:not(.is-disabled):hover {
            background-color: #0A95FF;
            color: #fff;
        }
        .popper__arrow::after {
            border-bottom-color: #eeeeee !important;
        }
        .el-dropdown-menu__item {
            padding: 0;
        }
    }

    .mt4-account-dialog {
        .title {
            font-size: 18px;
            font-weight: bold;
            line-height: 19px;
            color: #333333;
            text-align: center;
        }
        .el-dialog {
            border-radius: 10px;
        }
        .el-icon-close {
            font-size: 30px;
            &:hover {
                color: #0A95FF !important;
            }
        }
        .el-dialog__headerbtn:focus .el-dialog__close,
        .el-dialog__headerbtn:hover .el-dialog__close {
            color: #0A95FF !important;
        }
        .dialog-footer {
            text-align: center;
            display: block;
        }
    }

    .change-leverage-dialog {
        .select-view {
            margin-left: 80px;
            margin-top: 30px;
            label {
                padding-right: 20px;
            }
        }
        .info {
            width: 259px;
            height: 140px;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #333333;
            margin-left: 155px;
            margin-top: 10px;
        }
    }

    .change-account-dialog {
        .change-account-ruleForm {
            width: 400px;
            margin: 20px auto 0;
        }
    }

    .mt4-view {
        &-msgbox {
            &.el-message-box--center {
                width: 520px;
                padding: 30px 0 60px 0;
            }
            .ico-box {
                width: 60px;
                height: 60px;
                &.ico-success {
                    background: url('~assets/img/ico-successful.png');
                }
                &.ico-failed {
                    background: url('~assets/img/ico-failed.png');
                }
                &.ico-warning {
                    background: url('~assets/img/ico-warning.png');
                }
            }

            button.el-button--primary {
                width: 253px;
                height: 42px;
                margin-top: 10px;
                background: #0A95FF;
                border-radius: 4px;
                font-size: 16px;
                color: #fff;
                &:focus,
                &:hover {
                    color: #fff;
                    opacity: 0.9;
                }
            }
        }
    }
</style>
